import styled from 'styled-components';
import { BottomSns } from '../../common/BottomSnsImg';
import { mobileQuery } from '../../../utils';
import { OnlineInfo } from './OnlineInfo';
import { OfflineInfo } from './OfflineInfo';
import { tabStore } from '../../../store/tabStore';
import { MAIN_TAB_STATUS, SUB_TAB_STATUS } from '../../../types/type';

export const ParticipationInfo = () => {
  const { setSubTab, getCurrentSubTab } = tabStore();
  const activeSubTab = getCurrentSubTab(MAIN_TAB_STATUS.PARTICIPATE);

  return (
    <>
      <Wrap>
        <TabContainer>
          <TabButton
            $isActive={activeSubTab === SUB_TAB_STATUS.PARTICIPATE_ONLINE}
            onClick={() =>
              setSubTab(MAIN_TAB_STATUS.PARTICIPATE, SUB_TAB_STATUS.PARTICIPATE_ONLINE)
            }
          >
            <TabText $isActive={activeSubTab === SUB_TAB_STATUS.PARTICIPATE_ONLINE}>
              온라인 새틀라이트
            </TabText>
          </TabButton>

          <TabButton
            $isActive={activeSubTab === SUB_TAB_STATUS.PARTICIPATE_OFFLINE}
            onClick={() =>
              setSubTab(MAIN_TAB_STATUS.PARTICIPATE, SUB_TAB_STATUS.PARTICIPATE_OFFLINE)
            }
          >
            <TabText $isActive={activeSubTab === SUB_TAB_STATUS.PARTICIPATE_OFFLINE}>
              오프라인 이벤트
            </TabText>
          </TabButton>
        </TabContainer>

        <Content>
          {activeSubTab === SUB_TAB_STATUS.PARTICIPATE_ONLINE && <OnlineInfo />}
          {activeSubTab === SUB_TAB_STATUS.PARTICIPATE_OFFLINE && <OfflineInfo />}
        </Content>
      </Wrap>
      <BottomSns />
    </>
  );
};

const Wrap = styled.div`
  padding-bottom: 170px;
  padding-top: 40px;

  ${mobileQuery} {
    padding-top: 10px;
  }
`;

const Content = styled.div`
  ${mobileQuery} {
    padding-left: 13px;
    padding-right: 13px;
  }
`;

const TabContainer = styled.div`
  display: flex;
  max-width: 600px;
  margin: 0 auto;
  margin-bottom: 50px;

  ${mobileQuery} {
    margin-bottom: 15px;
    padding-top: 0px;
    padding-left: 15px;
    padding-right: 15px;
  }
`;

const TabButton = styled.div<{ $isActive: boolean }>`
  display: flex;
  flex: 1;
  height: 42px;
  border-radius: 30px;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.3s;
  background: ${(props) =>
    props.$isActive ? 'linear-gradient(97.36deg, #FFFFFF -31.96%, #FFD2D2 125.76%)' : '#434343'};
  border: 2px solid ${(props) => (props.$isActive ? 'rgba(65, 192, 255, 0.13)' : '#434343')};
  text-decoration: none;

  &:first-child {
    margin-right: 6px;
  }

  ${mobileQuery} {
    height: 31px;
  }
`;

const TabText = styled.h3<{ $isActive: boolean }>`
  font-weight: ${(props) => (props.$isActive ? '600' : '500')};
  font-size: 20px;
  line-height: 34px;
  color: ${(props) => (props.$isActive ? '#000000' : 'rgba(255, 255, 255, 0.50)')};

  ${mobileQuery} {
    font-size: 14px;
    line-height: 17px;
  }
`;
